import fetch from '../utils/fetch';

const PLANS_BASE = process.env.PLANS_API;

export default {
  checkPermissions(userId, permissions) {
    return fetch(`${PLANS_BASE}/plan/permissions/check?owner=${userId}&permissions=${permissions.join(',')}`);
  },

  getUserAccounts(userId) {
    return fetch(`${PLANS_BASE}/account/owners/${userId}?perm=graphics`);
  },

  getLegacyTeamOrg(teamId) {
    return fetch(`${PLANS_BASE}/org/legacyTeam/${teamId}`);
  },
};
